import { type FC } from 'react'
import { useSalesforceBasedContactSync } from '../IntegrationSpecificSettings/SalesforceBased/hooks'
import { IntegrationServiceId } from '../../../../common/integrations'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

const makeSalesforceBasedProvider = (serviceId: IntegrationServiceId): FC<CrmSettingsProviderProps> => {
  const Provider: FC<CrmSettingsProviderProps> = ({ children }) => {
    const contact = useSalesforceBasedContactSync(serviceId)

    const settings: CrmIntegrationSettings = {
      contactSync: contact.autoSync ?? false,
      calendarSync: false,
      isSyncDisabled: contact.isSyncDisabled,
      isFetching: contact.isFetching,
      isSaving: contact.isSaving,
      save: async (patch) => {
        if (patch.contactSync !== undefined) {
          await contact.saveAutoSync(patch.contactSync)
        }
      },
    }

    return <>{children(settings)}</>
  }

  Provider.displayName = `${serviceId}CrmSettingsProvider`
  return Provider
}

export const SalesforceCrmSettingsProvider = makeSalesforceBasedProvider(IntegrationServiceId.SALESFORCE)
export const PractifiCrmSettingsProvider = makeSalesforceBasedProvider(IntegrationServiceId.PRACTIFI)
export const XLR8CrmSettingsProvider = makeSalesforceBasedProvider(IntegrationServiceId.XLR8)
